export default __webpack_public_path__ + "static/media/zodiacToto-Rooster.1e32ac6b.png";